export default "__VITE_ASSET__BEc22kZW__"